import { render } from "./VehicleWheel.vue?vue&type=template&id=39c3cd1a"
import script from "./VehicleWheel.vue?vue&type=script&lang=js"
export * from "./VehicleWheel.vue?vue&type=script&lang=js"

import exportComponent from "/Users/fanhaipeng/code/giga-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__